import { render, staticRenderFns } from "./ColorIconContainer.vue?vue&type=template&id=18707cac&scoped=true"
import script from "./ColorIconContainer.vue?vue&type=script&lang=ts"
export * from "./ColorIconContainer.vue?vue&type=script&lang=ts"
import style0 from "./ColorIconContainer.vue?vue&type=style&index=0&id=18707cac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18707cac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18707cac')) {
      api.createRecord('18707cac', component.options)
    } else {
      api.reload('18707cac', component.options)
    }
    module.hot.accept("./ColorIconContainer.vue?vue&type=template&id=18707cac&scoped=true", function () {
      api.rerender('18707cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/ColorIconContainer.vue"
export default component.exports